import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class RoomBookingSearchAlternativeTime extends Component {
  static propTypes = {
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    timezone: PropTypes.string,
    searchCallback: PropTypes.func,
  }

  searchTime = () => {
    this.props.searchCallback(this.props.startTime, this.props.endTime);
  }

  render() {
    return (
      <div className="RoomSearch-result u-py-2 u-clearfix">
        <div className="RoomSearch-room">
          { `${moment(this.props.startTime).tz(this.props.timezone).format('h:mm A')} -
            ${moment(this.props.endTime).tz(this.props.timezone).format('h:mm A')}` }
        </div>
        <a
          onClick={this.searchTime}
          className="Button Button--xsmall u-float-right"
        >Search</a>
      </div>
    );
  }
}
